import Colors from '../../../../shared/assets/style/default/color';
import Screen from '../../../../shared/utils/screen';

function PlayOutlineIcon({ focused }: { focused?: boolean }) {
  return (
    <svg
      stroke={focused ? Colors['button']['text'] : Colors['light']}
      strokeWidth={'1px'}
      height={`${26 * Screen.widthRatio}`}
      width={`${26 * Screen.widthRatio}`}
      style={{ padding: `0 ${12 * Screen.widthRatio}px 0 0` }}
      xmlns={'http://www.w3.org/2000/svg'}
      viewBox={'0 0 24 24'}
    >
      <path d='M23 12l-22 12v-24l22 12zm-21 10.315l18.912-10.315-18.912-10.315v20.63z'></path>
    </svg>
  );
}

export default PlayOutlineIcon;
